<template>
  <div class="company-specific-info-card" :style="{ 'height': '60%'}">
    <div class="tabs-and-button-container">
    <tabs
      :tabs="tabs"
      :active-tab="activeTab"
      :tabs-styling="tabsStyling"
      :tabs-labels-styling="tabsLabelsStyling"
      :center-tabs="false"
      @startTabChange="activeTab = $event"
      />
      <!-- remove when ready to finalize the process to import keys
      <custom-button v-if="editingData !== false" :icon="'mdi-cloud-upload-outline'" :icon-size="13" :height="'20px'" :width="'20px'" style="border-radius: 0px; padding: 0px;"
      :button-styling="buttonStyling" @buttonClick="importTemplateDialog = true" /> -->
    </div>
    <div v-if="tabs[activeTab].id === 'fields'" :style="{'height': 'calc(100% - 102px)', 'margin-top': '21px'}">
      <Table
        :checkbox="false"
        :removeTableLines="false"
        :loading="loading"
        :headers="fieldsHeaders"
        :items="fields"
        :add-row-button="editingData"
        :action-buttons="editingData"
        @input="updateFieldValue($event)"
        @save="saveFields($event)"
      />
    </div>
    <div v-if="editingData" class="action-buttons">
      <custom-button
        :label="$t('Cancel')"
        :button-color="'#FFF'"
        :label-color="'#29BDF0'"
        :button-styling="actionButtonsStyling"
        @buttonClick="$emit('cancel-edit')"
      />
      <custom-button :label="$t(submitButtonLabel)" :button-color="'#29BDF0'" :label-color="'#FFF'"
        :button-styling="actionButtonsStylingSave" :disabled="!requiredFieldsFilled" @buttonClick="$emit('save-template')" />
    </div>

    <!-- dont delete comment until import templates is done
    <DialogContent :isOpen="importTemplateDialog" :isPersistent="false" :onClose="closeDialog">
      <template v-slot:content>
        <div style="height: 100%;">
          <div class="tabs-custom">
            <Tabs :tabs="tabsDialog" :activeTab="activeTabDialog" @startTabChange="handleTabChangeDialog"
              style="display: flex; align-items: left;" />
          </div>
          <div class="tabs-content-custom">
            <span class="span-custom">Material Family</span>
            <InputField :inputStyle="{
              backgroundColor: 'white',
            }" inputType="select" label="Type Format" :value="typeFileSelect" :select-options-list="typeFileSelectOptions" size="large" @input="updateField($event)"></InputField>
            <InputField :inputStyle="{
              color: '#767676 !important',
            }" inputType="file" size="large" ref="fileInput" :fileTypes="acceptedFileTypes" :value="file" @input="updateFile($event)">
            </InputField>
            <div class="buttons-container-custom">
              <div style="display: flex">
              </div>
              <div style="display: flex">
                <CustomButton :label="$t('Cancel')" :width="'2.74219rem'" :button-color="'#FFF'" :label-color="'#29BDF0'"
                  :buttonStyling="customButtonStylesSecondary" @buttonClick="handleSecondaryAction"></CustomButton>
                <CustomButton :label="$t('Submit')" :width="'2.74219rem'" :button-styling="customButtonStylesMain"
                  @buttonClick="submitUploadFileForm" :disabled="!submitButton">
                </CustomButton>
              </div>
            </div>
          </div>
        </div>
        <LoadingSpinner :active.sync="loadingUpload" :is-full-page="false" color="#29bdf0" />
      </template>
    </DialogContent> -->

  </div>
</template>

<script>
import Tabs from '@/newComponents/_Atoms/Tabs.vue';
import Table from '@/newComponents/_Molecules/Table';
import CustomButton from '@/newComponents/_Atoms/CustomButton'
import { mapActions } from "vuex";
import { bus } from "@/main.js";
import DialogContent from "@/newComponents/_Molecules/DialogContent.vue";
import InputField from "@/newComponents/_Atoms/InputField.vue";
import LoadingSpinner from "vue-loading-overlay";

export default {
  name: "ImportSpecificInfo",

  components: {
    Tabs,
    Table,
    CustomButton,
    DialogContent,
    InputField,
    LoadingSpinner,
  },

  props: {
    fields: {
      type: Array,
      required: true,
    },

    editingData:{
      type: Boolean,
    },

    submitButtonLabel: {
      type: String,
    },

    requiredFieldsFilled: {
      type: Boolean,
      required: true,
    },

    layerSelected: {
      type: String
    },
  },

  data() {
    return {
      activeTab: 0,
      importTemplateDialog: false,
      typeFileSelect: null,
      fileTypes: null,
      file: null,
      typeFileSelectOptions: [
        {
          name:"CSV",
          id:"csv",
        },
        {
          name:"Shape",
          id:"shape",
        },
      ],
      tabsDialog: [
        {
          label: "Upload File",
        },
      ],
      tabsStyling: {
        'margin': '0px 0px 8px 0px',
        'width': '100%',
        'height': '39px',
      },
      tabsLabelsStyling: {
        'text-transform': 'none',
        'font-size': '10px',
        'letter-spacing': '0',
      },
      loading: false,
      valueOptions: null,
      buttonStyling: {
        'padding': '0px',
        'drop-shadow': '0.85px 0.85px 1.75px rgba(0, 0, 0, 0.25)',
        'border-radius': '4px',
        'border': '1px solid #29BDF0',
      },
      actionButtonsStyling: {
        'border': '1px solid #29BDF0',
        'border-radius': '7px',
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600'
      },
      actionButtonsStylingSave: {
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600'
      },
    }
  },

  mounted() {
    this.loadFieldOptions();
  },

  watch:{
    "fields"() {
      if (!this.fields) {
        this.valueOptions = [];
        this.fields = [];
      }
    },

    "layerSelected"(){
      this.loadFieldOptions();
    }
  },

  computed: {

    tabs() {
      return [
        {
          id: 'fields',
          label: this.$i18n.tc("Fields", 2),
        },
      ]
    },

    fieldsHeaders() {
      return [
        {
          text: this.$i18n.tc('Key'),
          varName: "key",
          editable: true,
          type: "text",
          required: true,
          width: '30%'
        },
        {
          text: this.$i18n.tc('Value'),
          varName: "value",
          editable: this.valueIsEditable,
          type: "select",
          options: this.valueOptions,
          function: this.processValueID,
          required: true,
        },
        {
          text: this.$i18n.tc('DefaultValue'),
          varName: "default_value",
          editable: true,
          type: "text",
        },
      ]
    },

    acceptedFileTypes() {
      if (this.typeFileSelect === "shape") {
        return [".zip"];
      } else return ["." + this.typeFileSelect];
    },

    submitButton(){
      return this.file && this.typeFileSelect;
    },

  },

  methods: {
    ...mapActions(["FETCH_OBJECT_FORM_STRUCTURE_BY_OBJECT_TYPE", "fetchKeysFromFile"]),

    async loadFieldOptions() {
      try {
        if (
          this.layerSelected &&
          this.layerSelected !== "fc_building_mass_update"
        ) {
          let formFields = await this.FETCH_OBJECT_FORM_STRUCTURE_BY_OBJECT_TYPE(
            {
              layer: this.layerSelected,
              needsTabs: false,
              needsFields: true
            }
          );
          this.valueOptions = formFields.fields
          this.valueOptions.map((obj) =>{
            obj.code = obj.var_name;
            obj.label = obj.var_name + " (" + obj.label + ")";
            return obj;
          })
          this.getFieldOptionsInCreateMode(formFields.fields);
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    updateFieldValue(event) {
      this.fields[event.index].value = event.value;
    },

    processValueID(value){
      if (this.valueOptions && typeof value === "number") {
        let option = this.valueOptions.find(item => item.id === value);
        return option ? option.label : value;
      }
      return value;
    },

    getFieldOptionsInCreateMode(fields) {
      let fieldOptions = [];
      let allFieldOptions = [];
      if (fields && fields.length > 0) {
        fields.forEach(field => {
          if (
            !field.disable &&
            !field.hide &&
            field.input_type !== "" &&
            field.input_type !== " " &&
            field.input_type !== "other" &&
            field.input_type !== "date" &&
            field.input_type !== "datetime" &&
            field.input_type !== "group" &&
            field.input_type !== "checkbox" &&
            field.input_type !== "radio"
          ) {
            if (!this.editing) {
              fieldOptions.push(field);
            } else {
              allFieldOptions.push(field);
            }
          }
        });
      }
      if (this.editing) {
        this.valueOptions = allFieldOptions;
      } else {
        this.valueOptions = fieldOptions;
      }
    },

    valueIsEditable(index) {
      const field = this.fields[index];
      return field ? !field.originalData : false;
    },

    saveFields(event) {
      if (this.valueOptions && typeof event.value === "number") {
        const _option = this.valueOptions.find(op => op.id === event.value)
        const index = this.fields.findIndex(f => f.id === event.id)
        if (_option) {
          this.fields[index].value = _option.var_name;
        }
      }
    }
  }
}
</script>

<style scoped>
.company-specific-info-card {
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  padding: 17px 21px;
  flex: 1;
  position: relative;
  height: auto;
  max-height: 81%;
}

.tabs-and-button-container {
  display: flex;
  align-items: center;
  justify-content: space-between; /* Adjust as needed */
}

.button {
  box-shadow: 0px rgba(0, 0, 0, 0.25);
  border-radius: 80x;
  padding: 0px;
  flex: 1;
  position: relative;
  height: auto;
  max-height: 0%;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-end;
  position: absolute;
  right: 21px;
  bottom: 17px;
}

.buttons-container-custom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 20px;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/WorkspaceManagement/Templates/ImportSpecificInfo.vue